import * as React from 'react';
import { IBalanceProps } from '../types';
import { useAppContext } from '../../../../AppModulesWrapper';
import { useDispatch, useSelector } from 'react-redux';
import { selectAuctionPointsBalance, selectCanFillBalance, selectTotalBalance } from '../../../selectors/balance';
import { getBalanceString, getIsShowAgencyBalance } from '../utils';
import { useBalanceAnalytics } from './useBalanceAnalytics';
import { topUpBalanceThunk } from '../../../thunks/payment/topUpBalance';
import {
  selectCanPayByCard,
  selectIsAgencyBalanceVisible,
  selectIsMasterMoneySource,
  selectSubagentSpendLimit,
} from '../../../reducers/v2/user/selectors';

export const useBalance = (): IBalanceProps => {
  const { isMicrofrontend } = useAppContext();

  const dispatch = useDispatch();

  const { trackNaturalDepositLinkClick, trackLegalDepositLinkClick } = useBalanceAnalytics();

  const balance = useSelector(selectTotalBalance);
  const auctionPoints = useSelector(selectAuctionPointsBalance);
  const canFillBalance = useSelector(selectCanFillBalance);
  const isMasterMoneySource = useSelector(selectIsMasterMoneySource);
  const subAgentSpendLimit = useSelector(selectSubagentSpendLimit);
  const isAgencyBalanceVisible = useSelector(selectIsAgencyBalanceVisible);
  const canPayByCard = useSelector(selectCanPayByCard);

  const isSubagentSpendLimit = !!subAgentSpendLimit;

  const isShowAgencyBalance = getIsShowAgencyBalance({
    isMasterMoneySource,
    isSubagentSpendLimit,
    isAgencyBalanceVisible,
  });

  const balanceString = getBalanceString({ balance, auctionPoints, isShowAgencyBalance });

  const handleDepositLinkClick = React.useCallback(() => {
    if (canPayByCard) {
      trackNaturalDepositLinkClick();
    } else {
      trackLegalDepositLinkClick();
    }

    dispatch(topUpBalanceThunk(!!isMicrofrontend));
  }, [canPayByCard, dispatch, isMicrofrontend, trackNaturalDepositLinkClick, trackLegalDepositLinkClick]);

  return {
    showBalance: isMasterMoneySource ? isAgencyBalanceVisible : true,
    withPay: canFillBalance,
    balanceString,
    handleDepositLinkClick,
  };
};
